<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <a-select
        placeholder="请选择省份"
        :value="province"
        @select="handleSelect"
        @change="handleChangeProvince"
      >
        <a-select-option
          v-for="item in provinceData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </a-col>
    <a-col :span="12">
      <a-select
        placeholder="请选择城市"
        :value="city"
        @change="handleChangeCity"
      >
        <a-spin
          v-if="cityLoading"
          slot="notFoundContent"
          size="small"
        />
        <a-select-option
          v-for="item in cityData"
          v-else
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: ['value'],
  data() {
    const value = this.value || {};
    return {
      provinceData: [],
      cityData: [],
      province: value.province,
      city: value.city,
      path: '',
      cityLoading: true,
    };
  },
  watch: {
    value(val = {}) {
      this.province = val.province;
      this.city = val.city;
      console.log(111);
    },
    province(val) {
      console.log('province -> val', val);
      this.handleSelect(val);
      this.city = val?this.$props.value.city:undefined;
      console.log(2222);
    },
  },
  async mounted() {
    // 获取省市
    let result = await this.$http.post('/system/getRegionList');
    if (result.data.status === 1) {
      this.provinceData = result.data.data;
    }
  },

  methods: {
    // 选中省份
    async handleSelect(key) {
      this.city = '';
      let result = await this.$http.post('/system/getRegionList', {
        pid: key,
      });
      if (result.data.status === 1) {
        this.cityLoading = false;
        this.cityData = result.data.data;
      }
    },
    // change 省份
    handleChangeProvince(value) {
      this.$emit('change', {
        province: value,
        city: this.city,
      });
    },
    // change 城市
    handleChangeCity(value) {
      this.$emit('change', {
        province: this.province,
        city: value,
      });
    },
  },
};
</script>
